import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/vercel/path0/node_modules/.pnpm/react-hot-toast@2.6.0_react-dom@18.3.1_react@18.3.1/node_modules/react-hot-toast/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/styles/globals.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/@livekit+components-styles@1.1.6/node_modules/@livekit/components-styles/dist/general/index.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/@livekit+components-styles@1.1.6/node_modules/@livekit/components-styles/dist/general/prefabs/index.css");
